import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import QcGuidePage from "../pages/article-qc/page";
import VersandGuidePage from "../pages/article-versand/page";
import VerkaeuferGuidePage from "../pages/article-verkaeufer/page";
import SchuhePage from "../pages/article-schuhe/page";
import HoodiePage from "../pages/article-hoodie/page";
import JackenPage from "../pages/article-jacken/page";
import TaschenPage from "../pages/article-taschen/page";
import AccessoiresPage from "../pages/article-accessoires/page";
import SetsPage from "../pages/article-sets/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/artikel/oopbuy-qc-guide",
    element: <QcGuidePage />,
  },
  {
    path: "/artikel/oopbuy-versand-guide",
    element: <VersandGuidePage />,
  },
  {
    path: "/artikel/oopbuy-verkaeufer-guide",
    element: <VerkaeuferGuidePage />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-schuhe",
    element: <SchuhePage />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-hoodie",
    element: <HoodiePage />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-jacken",
    element: <JackenPage />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-taschen",
    element: <TaschenPage />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-accessoires",
    element: <AccessoiresPage />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-sets",
    element: <SetsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;